import React from 'react'

export const Error = () => {
  return (
    <div>Something went wrong</div>
  )
}
